import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import moment from "moment-timezone";
import Header from "../../Header/Header";
import Spinner from "../../Spinner/Spinner";
import { PieChart } from "react-minimal-pie-chart";
import InnerHTML from "dangerously-set-html-content";
import { get, post } from "../../../app/shared/http";
import loaderColors1 from "../../Spinner/loaderColors1.gif";
import {
  withAuth,
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../app/util/HOC";
export function PPClassStudentSubTopicPage() {
  const { isbn } = useParams();
  const history = useHistory();
  const location = useLocation();
  const classParams = location.state.ppClassInfo;
  const classStudParamas = location.state.ppStudentInfo;
  const classStudSubTopicParams = location.state.ppSubTopicInfo;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const [isPPPieChartLoad, setPPPieChartLoad] = useState(true);
  const [questsPerfDetails, setQuestsPerfDetails] = useState([]);
  const [submissionDetails, setSubmissionDetails] = useState({});
  const ppPageInfo = JSON.parse(localStorage.getItem("ppLandingInfo"));
  const { subTopicName, subTopictagId, topicName } = classStudSubTopicParams;
  const { ppClassId, ppClassName, ppClassCode, ppClassDescription } =
    classParams;
  const submittedData =
    Number(submissionDetails.submittedPercentage).toFixed(2) || 0;
  const ppIsbn =
    isbn && isbn !== "undefined" ? isbn : localStorage.getItem("bookIsbn");
  var excelRepoTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var excelRepoDateTime = new Date()
    .toLocaleString("en-US", { hour12: false })
    .replace(",", "");
  useEffect(() => {
    window.scrollTo(0, 0);
    getQuestionPerformance();
    getSubmissionPercentage();
  }, []);
  function getQuestionPerformance() {
    get(
      `/PP/Professor/getQuestionPerformance?classId=${ppClassId}&subtopicId=${subTopictagId}`,
      "qpAPI"
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.error === "Unauthorized") {
          window.location.replace(window.location.origin + "/login");
          return false;
        }
        setQuestsPerfDetails(data);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }
  function downlSubTopicSubmReport() {
    let reqData = {
      ppClassVO: {
        ppClassId: ppClassId,
        ppSubtopicId: subTopictagId,
        currentDate: excelRepoDateTime,
        timeZone: excelRepoTimeZone === "EDT" ? "EST" : excelRepoTimeZone,
      },
    };
    post("/PP/Professor/subtopicResultExcelForStudent", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.blob())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((blob) => {
        if (blob.type === "application/octet-stream") {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          const excelDownlDateTime = moment().format("MMDDYYYY");
          let fileName =
            "PP " +
            userVO.lastName +
            " " +
            ppClassCode +
            " " +
            subTopicName +
            " " +
            excelDownlDateTime +
            ".xlsx";
          const reg = /[/\\?%*:|"<>]/g;
          fileName = fileName.replace(reg, "_");
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          alert("Exception Occurs. Please try again later");
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }
  function getSubmissionPercentage() {
    get(
      `/PP/Professor/getSubmissionPercentage?classId=${ppClassId}&subTopicId=${subTopictagId}`,
      "qpAPI"
    )
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.error === "Unauthorized") {
          window.location.replace(window.location.origin + "/login");
          return false;
        }
        setSubmissionDetails(data);
        setPPPieChartLoad(false);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }
  const handlePieChartData = () => {
    if (submittedData == 100.0) {
      return [{ value: Number(submittedData), color: "#85BC20" }];
    } else if (submittedData == 0.0) {
      return [
        {
          value: Number((100 - Number(submittedData)).toFixed(2)),
          color: "#E5202E",
        },
      ];
    } else {
      return [
        { value: Number(submittedData), color: "#85BC20" },
        {
          value: Number((100 - Number(submittedData)).toFixed(2)),
          color: "#E5202E",
        },
      ];
    }
  };
  const handleClassSubTopicExpCollpAll = (qrExpandSt) => {
    const newQrExpandState = questsPerfDetails.map((quesListQues) => {
      return {
        ...quesListQues,
        choiceInteraction: {
          ...quesListQues.choiceInteraction,
          shuffle: qrExpandSt,
        },
      };
    });
    setQuestsPerfDetails(newQrExpandState);
  };
  const handleQuesListQuesExpand = (quesNo, quesExpandSt) => {
    const newQuesExpandState = questsPerfDetails.map((quesListQues, ind) => {
      if (ind + 1 === quesNo) {
        return {
          ...quesListQues,
          choiceInteraction: {
            ...quesListQues.choiceInteraction,
            shuffle: quesExpandSt,
          },
        };
      }
      return quesListQues;
    });
    setQuestsPerfDetails(newQuesExpandState);
  };
  const handleBacktoTopicPage = () => {
    history.push(`/pp-classes/${isbn}/pp-studentstopicscores`, {
      ppClassInfo: classParams,
      ppStudentInfo: classStudParamas,
    });
  };
  return (
    <>
      <Header
        userVO={userVO}
        pageName="PPClassStudentSubTopicPage"
        isbn={ppIsbn}
      ></Header>
      <div className="container">
        <div className="card ppClassContainerSection">
          <div className="card-body ppvContainerCard">
            <div className="row">
              <div className="col-12 p-0">
                {ppPageInfo && (
                  <div className="ppvLogoContainer pt-4">
                    <p>
                      <span className="ppvCommonStyle ppvLogoBoldText">
                        PracticePerfect
                      </span>
                      <span className="ppvCommonStyle ppvLogoText">
                        {ppPageInfo.ProductName}
                      </span>
                    </p>
                  </div>
                )}
                <div className="sticky-top TS-TabFirstSticky">
                  <div className="titleDesp-heights pt-2">
                    <h4
                      className={
                        ppClassName.length > 84
                          ? "ppClassesTitle ppClassesTitleGT mb-1"
                          : "ppClassesTitle ppClassesTitleLT mb-1"
                      }
                    >
                      {ppClassName}
                    </h4>
                    {ppClassDescription !== "" ? (
                      <p
                        className={
                          ppClassDescription.length > 168
                            ? "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpGT"
                            : "ppClassesDescp h6 pt-xl-3 pt-lg-3 pt-md-3 ppClassesDescpLT"
                        }
                      >
                        {ppClassDescription}
                      </p>
                    ) : null}
                  </div>
                  <>
                    <div className="ppSubTopicBackToTopicsText pt-4">
                      <a onClick={() => handleBacktoTopicPage()}>
                        <span className="backToQuizArrow fas fa-light fa-arrow-left"></span>
                        <span style={{ paddingLeft: "8px" }}>
                          Back To All Topics
                        </span>
                      </a>
                    </div>
                    <div className="ppSubTopicClassTopic mt-4">
                      Viewing: &nbsp;{topicName} &nbsp;
                      <i className="fas fa-solid fa-chevron-right"></i> &nbsp;
                      {subTopicName}
                    </div>
                    <div className="mt-3">
                      <a
                        className="ppSubTopicDownloadText"
                        onClick={() => downlSubTopicSubmReport()}
                      >
                        Download Submission Report
                      </a>
                    </div>
                    <div className="row col-lg-12 col-md-12 col-sm-12 col-12 no-padding mt-3">
                      <div className="submittedQuizText col-xl-6 col-lg-6 col-md-7 col-sm-12 col-12 no-padding">
                        <p style={{ paddingLeft: "3%" }}>
                          {isNaN(submittedData) ? 0 : submittedData}% of the
                          students have submitted the quiz
                        </p>
                        <div className="row">
                          <div
                            className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6"
                            style={{ top: "-5px" }}
                          >
                            {isPPPieChartLoad ? (
                              <PieChart
                                startAngle={0}
                                lengthAngle={360}
                                lineWidth={100}
                                radius={30}
                              />
                            ) : (
                              <PieChart
                                startAngle={0}
                                lengthAngle={360}
                                lineWidth={100}
                                data={handlePieChartData()}
                                radius={30}
                                label={({ dataEntry }) =>
                                  dataEntry.value === 100
                                    ? `100.00%`
                                    : `${dataEntry.value}%`
                                }
                                labelStyle={{
                                  fontSize: "8px",
                                  fontWeight: "bold",
                                  fontFamily: "Fira Sans",
                                  fill: "#000",
                                  opacity: 1,
                                }}
                                viewBoxSize={[100, 90]}
                                center={[50, 40]}
                                labelPosition={
                                  submittedData == 100.0 || submittedData == 0.0
                                    ? 0
                                    : 50
                                }
                              />
                            )}
                            <Spinner
                              loading={isPPPieChartLoad}
                              imageSrc={loaderColors1}
                              imageStyle={{
                                marginTop: "-95%",
                                width: "100px",
                                marginRight: "30px",
                              }}
                              overlayBackground="rgba(0,0,0,0)"
                            />
                          </div>
                          <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-center p-0">
                            <p className="piechartText mt-xl-5 mt-lg-5 mt-md-4 mt-4">
                              <span className="piechartSubmit"></span>Submitted
                            </p>
                            <p className="piechartText">
                              <span className="piechartNotSubmit"></span>Not
                              Submitted
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="cqProfQuizResultScores col-lg-6 col-md-5 col-sm-12 col-12">
                        <div className="cqProfQuizResultScoreDetails mt-3">
                          Average Score:{" "}
                        </div>
                        <div className="progress cqProfQuizResultOverallAvgProgr">
                          {submissionDetails.avgScore !== undefined ? (
                            Number(submissionDetails.avgScore) > 0 ? (
                              <>
                                <div
                                  className="progress-bar cqProfQuizResultOverallAvgProgrBar"
                                  style={{
                                    width:
                                      Number(submissionDetails.avgScore) + "%",
                                  }}
                                >
                                  {Number(submissionDetails.avgScore) > 16
                                    ? Number(
                                        submissionDetails.avgScore
                                      ).toFixed(2) + "%"
                                    : null}
                                </div>
                                {Number(submissionDetails.avgScore) >
                                16 ? null : (
                                  <div className="progress-bar cqProfQuizResultOverallAvgProgrBarLess16">
                                    {Number(submissionDetails.avgScore).toFixed(
                                      2
                                    ) + "%"}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallAvgProgrBarZero">
                                {submissionDetails.avgScore + "%"}
                              </div>
                            )
                          ) : null}
                        </div>
                        <div className="ppSubTopicMinMaxProgressBar mt-2">
                          Lowest Score:{" "}
                        </div>
                        <div className="progress cqProfQuizResultOverallMinMaxProgr">
                          {submissionDetails.minScore !== undefined ? (
                            Number(submissionDetails.minScore) > 0 ? (
                              <>
                                <div
                                  className="progress-bar cqProfQuizResultOverallMinMaxProgrBar"
                                  style={{
                                    width:
                                      Number(submissionDetails.minScore) + "%",
                                  }}
                                >
                                  {Number(submissionDetails.minScore) > 16
                                    ? Number(
                                        submissionDetails.minScore
                                      ).toFixed(2) + "%"
                                    : null}
                                </div>
                                {Number(submissionDetails.minScore) >
                                16 ? null : (
                                  <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarLess16">
                                    {Number(submissionDetails.minScore).toFixed(
                                      2
                                    ) + "%"}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarZero">
                                {submissionDetails.minScore + "%"}
                              </div>
                            )
                          ) : null}
                        </div>
                        <div className="ppSubTopicMinMaxProgressBar mt-2">
                          Highest Score:{" "}
                        </div>
                        <div className="progress cqProfQuizResultOverallMinMaxProgr">
                          {submissionDetails.maxScore !== undefined ? (
                            Number(submissionDetails.maxScore) > 0 ? (
                              <>
                                <div
                                  className="progress-bar cqProfQuizResultOverallMinMaxProgrBar"
                                  style={{
                                    width:
                                      Number(submissionDetails.maxScore) + "%",
                                  }}
                                >
                                  {Number(submissionDetails.maxScore) > 16
                                    ? Number(
                                        submissionDetails.maxScore
                                      ).toFixed(2) + "%"
                                    : null}
                                </div>
                                {Number(submissionDetails.maxScore) >
                                16 ? null : (
                                  <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarLess16">
                                    {Number(submissionDetails.maxScore).toFixed(
                                      2
                                    ) + "%"}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="progress-bar cqProfQuizResultOverallMinMaxProgrBarZero">
                                {submissionDetails.maxScore + "%"}
                              </div>
                            )
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row mr-2">
                      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 questionPerformanceText mt-3">
                        Question Performance
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right mt-3">
                        <a
                          aria-selected="false"
                          onClick={() => handleClassSubTopicExpCollpAll(true)}
                        >
                          <span className="ppQuizCentPreviewExpCollpAll">
                            Expand All
                          </span>
                        </a>
                        <span> | </span>
                        <a
                          aria-selected="true"
                          onClick={() => handleClassSubTopicExpCollpAll(false)}
                        >
                          <span className="ppQuizCentPreviewExpCollpAll">
                            Collapse All
                          </span>
                        </a>
                      </div>
                    </div>
                    <div className="card card-body pl-xl-3 pl-lg-3 pl-md-3 pl-sm-0 pl-0 mt-2">
                      {questsPerfDetails && questsPerfDetails.length
                        ? questsPerfDetails.map((quesListQues, ind) => {
                           
                            return (
                              <>
                                <div
                                  key={ind}
                                  className="cqProfQuizResultQuizzesTxt row mb-2"
                                  style={{ color: "#007AC3" }}
                                >
                                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div
                                      data-testid="expand"
                                      className="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-3 no-padding float-right"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleQuesListQuesExpand(
                                          ind + 1,
                                          quesListQues.choiceInteraction
                                            .shuffle === true
                                            ? false
                                            : true
                                        )
                                      }
                                    >
                                      <span className="ppProfQuizResultAnsTxt">
                                        <i
                                          className="fas fa-check cqProfQuizResultCheckIcon"
                                          title="Correct answer"
                                          role="img"
                                        ></i>
                                        <span style={{ marginLeft: "7%" }}>
                                          {quesListQues.correctPercentage ===
                                          100.0
                                            ? `${Math.round(
                                                quesListQues.correctPercentage
                                              )}%`
                                            : `${quesListQues.correctPercentage}%`}
                                        </span>
                                      </span>
                                    </div>
                                    <InnerHTML
                                      html={quesListQues.promptText}
                                      className={
                                        quesListQues.choiceInteraction
                                          .shuffle === true
                                          ? "cqProfQuizResultQuesTxtExpa cqProfQuizResultQuesTxtMar col-xl-11 col-lg-10 col-md-10 col-sm-12 col-12 p-0 d-inline-block px-0 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2 pl-xl-0 pl-lg-0 pl-md-0 pl-2"
                                          : "cqProfQuizResultQuesTxtShort cqProfQuizResultQuesTxtMar col-xl-11 col-lg-10 col-md-10 col-sm-9 col-9 p-0 d-inline-block px-0 mt-0 pr-2"
                                      }
                                      style={{ marginLeft: "-1%" }}
                                      onClick={() =>
                                        handleQuesListQuesExpand(
                                          ind + 1,
                                          quesListQues.choiceInteraction
                                            .shuffle === true
                                            ? false
                                            : true
                                        )
                                      }
                                    />
                                  </div>
                                  {quesListQues.choiceInteraction.shuffle ===
                                  true ? (
                                    <div className="border-bottom mt-2 w-100">
                                      {quesListQues.choiceInteraction.simpleChoices.map(
                                        (quesListQuesOpt, i) => {
                                          return (
                                            <>
                                              <div key={i} className="row mb-2">
                                                <div className="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2-half pt-2 text-right">
                                                  {quesListQuesOpt.correct ===
                                                  true ? (
                                                    <span className="ppProfQuizResultAnsTxt">
                                                      <span>
                                                        {quesListQuesOpt.userResponsePercentage ===
                                                        100.0
                                                          ? `${Math.round(
                                                              quesListQuesOpt.userResponsePercentage
                                                            )}%`
                                                          : `${quesListQuesOpt.userResponsePercentage}%`}
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    <span className="ppProfQuizResultAnsTxt">
                                                      <span>
                                                        {quesListQuesOpt.userResponsePercentage ===
                                                        100.0
                                                          ? `${Math.round(
                                                              quesListQuesOpt.userResponsePercentage
                                                            )}%`
                                                          : `${quesListQuesOpt.userResponsePercentage}%`}
                                                      </span>
                                                    </span>
                                                  )}
                                                </div>
                                                <div
                                                  className="ppSrDisplayBlock ppSrOptBox col-xl-1 col-lg-1 col-md-1 col-sm-4 col-2"
                                                  style={
                                                    quesListQuesOpt.correct ===
                                                    true
                                                      ? {
                                                          background:
                                                            "rgb(213, 232, 177)",
                                                        }
                                                      : {
                                                          background: "#F8B3B3",
                                                        }
                                                  }
                                                >
                                                  {quesListQuesOpt.correct ===
                                                  true ? (
                                                    <i className="fas fa-check ppSrOptCheck"></i>
                                                  ) : (
                                                    <i className="fas fa-times ppDashQrOptWrong"></i>
                                                  )}
                                                </div>
                                                <span
                                                  className="ppSrQuesNumIndex"
                                                  style={{ right: "24px" }}
                                                >
                                                  {quesListQuesOpt.label.replace(
                                                    /[\])}[{(]/g,
                                                    ""
                                                  )}
                                                </span>
                                                <div className="ppQrDisplayBlock ppProfQuizResultText col-xl-9 col-lg-9 col-md-8 col-sm-9 col-7 pl-0">
                                                  <p className="pt-1">
                                                    <InnerHTML
                                                      html={
                                                        quesListQuesOpt.answerText
                                                      }
                                                    />
                                                  </p>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )}
                                      <div
                                        className="col-xl-10 col-lg-10 col-md-10 col-sm-11 col-11"
                                        style={{ marginLeft: "5%" }}
                                      >
                                        {quesListQues.rationale !==
                                        undefined ? (
                                          <>
                                            <p className="ppProfQuizResultText">
                                              {" "}
                                              Rationale:
                                            </p>
                                            <div
                                              id="ppProfQuizResultText"
                                              className="ppProfQuizResultText"
                                            >
                                              <InnerHTML
                                                html={quesListQues.rationale.map(
                                                  (data) => data.feedbackText
                                                )}
                                              />
                                            </div>
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </>
                            );
                          })
                        : null}
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withAuth(PPClassStudentSubTopicPage);
